import { render } from "./Pinned.vue?vue&type=template&id=6131f8d8&scoped=true"
import script from "./Pinned.vue?vue&type=script&lang=js"
export * from "./Pinned.vue?vue&type=script&lang=js"

import "./Pinned.vue?vue&type=style&index=0&id=6131f8d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6131f8d8"

export default script